'use client';

import { c as _c } from "react/compiler-runtime";
import { type LucideIcon } from 'lucide-react';
import { type Ref } from 'react';

// Default icon size for every info chip (Links / Citations / Locations / Users
// on the always-show row, plus Archive in view more). Change this one value to
// resize them all together; pass the `iconSize` prop to override a single chip.
export const CHIP_ICON_SIZE = 15;
type Props = {
  // The Lucide icon component itself (not a rendered element) so the chip owns
  // its size — that's what makes the size adjustable in one place.
  icon: LucideIcon;
  count: number;
  active: boolean;
  onHoverOpen: (rect: DOMRect) => void;
  onHoverClose: () => void;
  onToggleClick: (rect: DOMRect) => void;
  buttonRef?: Ref<HTMLButtonElement>;
  iconSize?: number;
};

// A single info "chip" on a post's factiii row: an icon + a count that opens its
// detail popover on hover (desktop) or tap. Shared by every info holder.
export default function FactiiiInfoChip(t0) {
  const $ = _c(24);
  const {
    icon: Icon,
    count,
    active,
    onHoverOpen,
    onHoverClose,
    onToggleClick,
    buttonRef,
    iconSize: t1
  } = t0;
  const iconSize = t1 === undefined ? CHIP_ICON_SIZE : t1;
  let t2;
  if ($[0] !== onHoverOpen) {
    t2 = e => {
      if (e.pointerType !== "mouse") {
        return;
      }
      onHoverOpen(e.currentTarget.getBoundingClientRect());
    };
    $[0] = onHoverOpen;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onHoverClose) {
    t3 = e_0 => {
      if (e_0.pointerType !== "mouse") {
        return;
      }
      onHoverClose();
    };
    $[2] = onHoverClose;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onHoverOpen) {
    t4 = e_1 => onHoverOpen(e_1.currentTarget.getBoundingClientRect());
    $[4] = onHoverOpen;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== onToggleClick) {
    t5 = e_2 => {
      e_2.stopPropagation();
      onToggleClick(e_2.currentTarget.getBoundingClientRect());
    };
    $[6] = onToggleClick;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = `flex items-center gap-1 rounded-md border px-1.5 py-1 text-xs transition-colors ${active ? "border-primary/60 bg-primary/10 text-textPrimary" : "border-ds-border-standard bg-background-secondary text-textSecondary hover:border-primary/40 hover:text-textPrimary"}`;
  let t7;
  if ($[8] !== Icon || $[9] !== iconSize) {
    t7 = <Icon size={iconSize} />;
    $[8] = Icon;
    $[9] = iconSize;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== count) {
    t8 = <span className="font-emphasis leading-none">{count}</span>;
    $[11] = count;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== active || $[14] !== buttonRef || $[15] !== onHoverClose || $[16] !== t2 || $[17] !== t3 || $[18] !== t4 || $[19] !== t5 || $[20] !== t6 || $[21] !== t7 || $[22] !== t8) {
    t9 = <button type="button" ref={buttonRef} data-post-factiiis-trigger="true" onPointerEnter={t2} onPointerLeave={t3} onFocus={t4} onBlur={onHoverClose} onClick={t5} aria-expanded={active} className={t6}>{t7}{t8}</button>;
    $[13] = active;
    $[14] = buttonRef;
    $[15] = onHoverClose;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
}